<template>
	<div class="indexView">
		<el-container>
			<el-main>
				<HeaderRow selUrl="custom"></HeaderRow>
				<div class="breadcrumb">
					<div class="backItem" @click="()=>$router.back()"><i class="el-icon-arrow-left">返回</i></div>
					<el-breadcrumb separator="/">
						<el-breadcrumb-item to="/">首页</el-breadcrumb-item>
						<el-breadcrumb-item to="/custom">定制课程</el-breadcrumb-item>
						<el-breadcrumb-item>详情</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
				<p>开发中...</p>
			</el-main>
		</el-container>
	</div>
</template>

<script>
	import indexjs from "./";
	import {
		copy
	} from "clipboard";
	import FooterRow from "@/components/footerRow.vue";
	import LoginDialog from "@/components/loginDialog.vue";
	import HeaderRow from "@/components/headerRow.vue";

	export default {
		methods: {
			copy,
		},
		...indexjs,
		components: {
			HeaderRow,
			FooterRow,
			LoginDialog
		},
		computed: {},

	};
</script>

<style lang="scss" scoped>
	@import "index";
</style>